// rolex menu toggle
document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(".rolex-menu-button");
  const mobileMenu = document.querySelector(".rolex-navigation-mobile-wrapper");
  const toggle_icon = document.querySelector(".rolex-menu-button");
  if (!toggleButton) return;
  if (!mobileMenu) return;
  if (!toggle_icon) return;

  toggleButton.addEventListener("click", function (e) {
    e.preventDefault();
    if (mobileMenu.hasAttribute("active")) {
      // Hide menu
      mobileMenu.removeAttribute("active");
      toggle_icon.removeAttribute("active");
       } else {
      // Show menu
      mobileMenu.setAttribute("active", "");
      toggle_icon.setAttribute("active", "");
       }
  });
});


// rolex discover image slider
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.rolex-banner-slider');
  if (!slider) return;

  const showArrows = slider.dataset.showArrows === 'true';
  const showPagination = slider.dataset.showPagination === 'true';

  new Splide(slider, {
    type: 'loop',
    perPage: 1,
    arrows: showArrows,
    pagination: showPagination,
    autoplay: false,
    interval: 5000,
    pauseOnHover: true,
    accessibility : true,
    keyboard:'global',
    slideFocus: false,
    breakpoints: {
      767: {
        arrows: false,
      },
    },
  }).mount();
});

// Rolex Bespoke tabs
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("ul.r7-contact-tabs").forEach(function (tabList) {
    const links = tabList.querySelectorAll("a");

    let active = links[0];
    active.classList.add("r7-tab-active");

    let content = document.querySelector(active.getAttribute("href"));

    // Hide all except first
    links.forEach(function (link, index) {
      if (index !== 0) {
        const section = document.querySelector(link.getAttribute("href"));
        if (section) section.style.display = "none";
      }
    });

    // Add click events
    links.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        // Deactivate current
        if (active) active.classList.remove("r7-tab-active");
        if (content) content.style.display = "none";

        // Activate new
        active = this;
        content = document.querySelector(active.getAttribute("href"));

        active.classList.add("r7-tab-active");
        if (content) content.style.display = "block";
      });
    });
  });
});


// Shows Price Info on Rolex product page
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("show-price-info");
  const infoArea = document.querySelector(".inf-area");

  if (btn && infoArea) {
    btn.addEventListener("click", function () {
      infoArea.classList.toggle("active");
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
    function applyTabIndex() {
        const elements = document.querySelectorAll(
            ".globo-paragraph, .globo-heading, .heading-caption, .rpo-form_location > label.globo-label"
        );

        elements.forEach(function(el){
            el.setAttribute("tabindex", "-1");
        });
    }
    applyTabIndex();

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function() {
            applyTabIndex(); 
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});


document.addEventListener("DOMContentLoaded", function () {

  /* ------------------------------------------------------------------
     1) If .rolex-header is present inside #MainContent, add "has-rolex"
  ------------------------------------------------------------------ */
  const mainContent = document.getElementById("MainContent");
  if (mainContent && mainContent.querySelector(".rolex-header")) {
    mainContent.classList.add("has-rolex");
  }

  /* ------------------------------------------------------------------
     2) If #MainContent has class "has-rolex", enable keyboard-only behavior
        - Pressing TAB will add class "keyfocus" on #MainContent
        - Any mouse click will remove class "keyfocus"
     ------------------------------------------------------------------ */
  if (!mainContent || !mainContent.classList.contains("has-rolex")) return;

  // Add keyfocus when user presses Tab (keyboard navigation)
  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab") {
      mainContent.classList.add("keyfocus");
    }
  });

  // Remove keyfocus on mouse interaction
  document.addEventListener("mousedown", function () {
    mainContent.classList.remove("keyfocus");
  });

});


// Rolex Bespoke keep exploring
document.addEventListener('DOMContentLoaded', function () {
    const selector = '#keep-exploring-splide';
    const slider   = document.querySelector(selector);

    if (!slider) return;

    const showArrows     = slider.dataset.showArrows === 'true';
    const showPagination = slider.dataset.showPagination === 'true';

    const splide = new Splide(slider, {
        type         : 'slide',
        perPage      : 4,
        gap          : '8px',

        arrows       : showArrows,
        pagination   : showPagination,

        accessibility: true,
        keyboard     : 'global',
        slideFocus   : false,

        // ✅ Re-enable drag/swipe (mobile + tablet)
        drag         : true,
        // swipe: true, // optional, true by default

        breakpoints: {
            1024: { perPage: 4 },
            768 : { perPage: 3 },
            480 : { perPage: 2 },
        },
    });

    splide.mount();

    // No attachSplideFocusHandler here

    disableSplideArrowsFocus(selector);
    disableSplidePaginationFocus(splide, selector);
    attachSplideKeyboardRoving(splide, selector);
});

// Arrows not focusable
function disableSplideArrowsFocus(selector) {
    const root = document.querySelector(selector);
    if (!root) return;

    const arrows = root.querySelectorAll('.splide__arrow');
    arrows.forEach(arrow => {
        arrow.setAttribute('tabindex', '-1');
    });
}

// Dots not focusable
function disableSplidePaginationFocus(splideInstance, selector) {
    const root = document.querySelector(selector);
    if (!root) return;

    const setPaginationTabIndex = function () {
        const dots = root.querySelectorAll('.splide__pagination__page');
        dots.forEach(dot => {
            dot.setAttribute('tabindex', '-1');
        });
    };

    setPaginationTabIndex();
    splideInstance.on('moved', setPaginationTabIndex);
}

// Roving tabindex across all slide links
function attachSplideKeyboardRoving(splideInstance, selector) {
    const root = document.querySelector(selector);
    if (!root) return;

    const links = Array.prototype.slice.call(
        root.querySelectorAll('.splide__slide .explore-item a')
    );
    if (!links.length) return;

    // Hint to Splide that these elements shouldn’t start a drag
    links.forEach(link => {
        link.setAttribute('data-splide-no-drag', 'true');
    });

    function setActiveLink(index) {
        links.forEach(link => link.setAttribute('tabindex', '-1'));
        if (links[index]) {
            links[index].setAttribute('tabindex', '0');
        }
    }

    let initialIndex = 0;
    const activeSlideLink = root.querySelector('.splide__slide.is-active .explore-item a');
    if (activeSlideLink) {
        const idx = links.indexOf(activeSlideLink);
        if (idx !== -1) initialIndex = idx;
    }
    setActiveLink(initialIndex);

    splideInstance.on('moved', function (newIndex) {
        setActiveLink(newIndex);
    });

    root.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;

        const current = document.activeElement;
        const currentIndex = links.indexOf(current);

        if (currentIndex === -1) return;

        if (event.shiftKey) {
            // Shift+Tab backwards
            if (currentIndex === 0) {
                setActiveLink(0);
                return;
            }

            event.preventDefault();
            const prevIndex = currentIndex - 1;
            setActiveLink(prevIndex);
            splideInstance.go(prevIndex);
            links[prevIndex].focus();
        } else {
            // Tab forwards
            if (currentIndex === links.length - 1) {
                setActiveLink(currentIndex);
                return;
            }

            event.preventDefault();
            const nextIndex = currentIndex + 1;
            setActiveLink(nextIndex);
            splideInstance.go(nextIndex);
            links[nextIndex].focus();
        }
    });
}


// skip links js
document.addEventListener('DOMContentLoaded', function () {

  const links = document.querySelectorAll('.skip-links .skip-link');
  if (!links.length) return;

  links.forEach(function (link) {

    link.addEventListener('click', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('data-target');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      // --- Smooth scroll ---
      try {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } catch (e) {
        // Fallback
        target.scrollIntoView(true);
      }

      // --- Move keyboard focus for accessibility ---
      setTimeout(function () {
        const hadTabindex = target.hasAttribute('tabindex');

        if (!hadTabindex) {
          // Make it temporarily focusable
          target.setAttribute('tabindex', '-1');
        }

        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          // Older browsers
          target.focus();
        }

        // Clean up if we added tabindex
        if (!hadTabindex) {
          setTimeout(() => target.removeAttribute('tabindex'), 800);
        }

      }, 300);
    });

  });

});




document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".r7-item-card");

  const now = new Date();
  const currentDay = now.getDay(); // 0 = Sunday
  const currentTime = now.getHours() * 60 + now.getMinutes();

  const dayMap = ["sun","mon","tue","wed","thu","fri","sat"];

  // ✅ Smart Time Parser (AM/PM + 24h + auto-fix)
  function parseTime(timeStr) {
    if (!timeStr) return null;

    timeStr = timeStr.trim().toLowerCase();

    let isPM = timeStr.includes("pm");
    let isAM = timeStr.includes("am");

    timeStr = timeStr.replace(/am|pm/g, "").trim();

    let [hours, minutes] = timeStr.split(":").map(Number);

    if (isNaN(hours)) return null;
    if (!minutes) minutes = 0;

    // AM/PM handling
    if (isPM && hours < 12) hours += 12;
    if (isAM && hours === 12) hours = 0;

    return {
      minutes: hours * 60 + minutes,
      hasAmPm: isAM || isPM
    };
  }

  // ✅ Format 12h
  function format12h(minutes) {
    let h = Math.floor(minutes / 60);
    let m = minutes % 60;

    let ampm = h >= 12 ? "pm" : "am";

    h = h % 12;
    if (h === 0) h = 12;

    return `${h}:${m.toString().padStart(2, "0")}${ampm}`;
  }

  cards.forEach(card => {

    const weeklyData = card.dataset.weekly;
    if (!weeklyData) return;

    let schedule;

    try {
      schedule = JSON.parse(weeklyData);
    } catch (e) {
      console.error("Invalid JSON timing", e);
      return;
    }

    const todayKey = dayMap[currentDay];
    const todayTiming = schedule[todayKey];

    const statusEl = card.querySelector(".status-text");
    const timeEl = card.querySelector(".time-range");

    // ❌ Closed
    if (!todayTiming || todayTiming.toLowerCase() === "closed") {
      if (statusEl) {
        statusEl.textContent = "Currently Closed";
        statusEl.classList.remove("open", "closed");
        statusEl.classList.add("closed");
      }
      if (timeEl) timeEl.textContent = "Closed";
      return;
    }

    const [openStr, closeStr] = todayTiming.split("-");

    const openObj = parseTime(openStr);
    const closeObj = parseTime(closeStr);

    if (!openObj || !closeObj) return;

    let openMinutes = openObj.minutes;
    let closeMinutes = closeObj.minutes;

    const hasAmPm = openObj.hasAmPm || closeObj.hasAmPm;

    // ✅ FIX: agar AM/PM missing hai aur close < open
    if (!hasAmPm && closeMinutes < openMinutes) {
      closeMinutes += 12 * 60; // assume PM
    }

    let isOpen;

    // ✅ Overnight case (real one like 10 PM - 2 AM)
    if (closeMinutes < openMinutes) {
      isOpen = currentTime >= openMinutes || currentTime < closeMinutes;
    } else {
      // ✅ Exact close time fix
      isOpen = currentTime >= openMinutes && currentTime < closeMinutes;
    }

    // ✅ Status
    if (statusEl) {
      statusEl.textContent = isOpen ? "Currently Open" : "Currently Closed";
      statusEl.classList.remove("open", "closed");
      statusEl.classList.add(isOpen ? "open" : "closed");
    }

    // ✅ Display always AM/PM
    if (timeEl) {
      timeEl.textContent = `${format12h(openMinutes)} - ${format12h(closeMinutes)}`;
    }

  });

});

// document.addEventListener("DOMContentLoaded", function () {
//   const retailerList = document.getElementById("retailer-list");
//   const toggleBtn = document.querySelector(".toggle-retailer");
//   if (!retailerList || !toggleBtn) return;

//   toggleBtn.addEventListener("click", function () {
//     retailerList.classList.toggle("active");
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const retailerList = document.getElementById("retailer-list");
  const toggleBtn = document.querySelector(".toggle-retailer");
  const toggleText = document.querySelector(".toggle-retailer-text");

  if (!retailerList || !toggleBtn || !toggleText) return;

  const originalText = toggleText.textContent;

  toggleBtn.addEventListener("click", function () {
    retailerList.classList.toggle("active");

    if (retailerList.classList.contains("active")) {
      toggleText.textContent = "Map";
    } else {
      toggleText.textContent = originalText;
    }
  });
});